import { CustomDialogProps } from '@/dashboard/components/Dialog/index';
import { EmojiHappyIcon } from '@heroicons/react/outline';
import { Box, Button, Typography } from '@mui/material';

type CancelPolicyDialogSuccessViewProps = CustomDialogProps & {
  close?: () => void;
  refresh?: () => void;
};
const CancelPolicyDialogSuccessView = (props: CancelPolicyDialogSuccessViewProps) => {
  const { close, refresh } = props;

  /**
   * methods
   */
  const backAction = () => {
    close?.();
    refresh?.();
  };

  return (
    <Box className="mt-4 flex flex-col items-center">
      <Box className="bg-brand-secondary/20 text-brand-secondary rounded-full p-2">
        <EmojiHappyIcon className="h-7 w-7" />
      </Box>
      <Typography className="text-black-secondary mt-4 text-center font-black" variant="h5">
        Thank you for your cancellation request. We are reviewing the request and will get back to you.
      </Typography>
      <Button className="mt-10 h-12 w-[210px] rounded-full text-lg font-bold" color="primary" onClick={backAction} variant="contained">
        Back to My policies
      </Button>
    </Box>
  );
};

export default CancelPolicyDialogSuccessView;
